import React, { useState, useEffect } from 'react';
import NotificationOverlay from '@/notification-popup/views/NotificationPopupOverlay';
import { sortTournaments } from '@/notification-popup/handlers';
import { dispatch, useReframe } from 'nike-re-framejs';
import { useInterval } from 'nike-ui/src/common/hooks/useInterval';
import { initAvailableTournaments } from '@/tournaments/handlers';
import {
    getTournamentsPriority$,
    initNotificationBox,
    notificationPopupStatus$
} from 'nike-ui/src/components/notification-popup/reframe/h&s';
import { isBetslipOpen$ } from '@/betslip/subs';
import { popup$ } from '@/ui/subs';

function NotificationBox() {
    useInterval(() => {
        dispatch(initNotificationBox);
        dispatch(sortTournaments);
    }, 5 * 60000);
    useEffect(() => {
        dispatch(initAvailableTournaments);
    }, []);
    const [used, setUsed] = useState(false);
    const { subscribe } = useReframe();
    const shown = subscribe(notificationPopupStatus$);
    const isBetslipOpen = subscribe(isBetslipOpen$);
    const allIds = subscribe(getTournamentsPriority$) || {};
    const popupOpened = subscribe(popup$);

    useInterval(
        () => {
            setUsed(true);
            dispatch(initNotificationBox);
            dispatch(sortTournaments);
        },
        used ? null : 10000
    );
    return shown && !isBetslipOpen && Object.keys(allIds).length > 0 && !popupOpened ? <NotificationOverlay /> : null;
}

export default NotificationBox;
